import React from 'react';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// 1. Importa el CSS base de Bootstrap (CoreUI lo requiere)
import 'bootstrap/dist/css/bootstrap.min.css'; 
// 2. Importa el tema principal de CoreUI (para dar estilo al Sidebar)
import '@coreui/coreui/dist/css/coreui.min.css';

// Enrutamiento de destinos
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";

// Páginas
import Home from './components/Content/Home';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import AuthCallback from './components/Auth/AuthCallback';
import Destinos from './components/Admin/Destinos';
import Publicidads from './components/Admin/Publicidads';
import Slides from './components/Admin/Slides';
import AdminCruds from './components/Admin/AdminCruds';
import Usuarios from './components/Admin/Usuarios';
import AdminPage from './components/Admin/AdminPage';
import ListCatalogo from "./components/pages/ListCatalogo";
import AdminLayout from './layout/AdminLayout';
import SessionManager from './components/Auth/SessionManager';

import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';


import AtractivosTuristicos from './components/pages/atractivos-turisticos';
import CircuitosTuristicos from './components/pages/circuitos-turisticos';
import HotelesTuristicos from './components/pages/hoteles-turisticos';
import HostalesTuristicos from './components/pages/hostales-turisticos';
import Gatronomia from './components/pages/gastronomia';
import Agencias from './components/pages/agencias';
import GuiasTuristicos from './components/pages/guias-turisticos';
import Artesanias from './components/pages/artesanias';
import CentrosComerciales from './components/pages/centros-comerciales';
import TransportePublico from './components/pages/transporte-publico';
import InformacionPage from './components/pages/informacion';
import ProtectedRoute from './components/Auth/ProtectedRoute';

const App = () => {
  return (
    <Router>

      <SessionManager />

      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        {/* Contenido principal haciendo prueba*/}
        <div style={{ flex: 1 }}>
          <Routes>
            {/* Rutas públicas */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth-callback" element={<AuthCallback />} />
            <Route path="/atractivos turisticos" element={<AtractivosTuristicos />} />
            <Route path="/circuitos turisticos" element={<CircuitosTuristicos />} />
            <Route path="/hoteles turisticos" element={<HotelesTuristicos />} />
            <Route path="/hostales turisticos" element={<HostalesTuristicos />} />
            <Route path="/gastronomia" element={<Gatronomia />} />
            <Route path="/agencias" element={<Agencias />} />
            <Route path="/guias turisticos" element={<GuiasTuristicos />} />
            <Route path="/artesanias" element={<Artesanias />} />
            <Route path="/centros comerciales" element={<CentrosComerciales />} />
            <Route path="/transporte publico" element={<TransportePublico />} />
            {/*<Route path="/informacion/:id" element={<Informacion />} />*/}
            <Route path="/informacion/:id" element={<InformacionPage />} />
            <Route path="/listcatalogo" element={<ListCatalogo />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            
            {/* Admin Layout protegido */}
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute rolesAllowed={['admin', 'superadmin']}>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="destinos" element={<Destinos />} />
              <Route path="publicidads" element={<Publicidads />} />
              <Route path="slides" element={<Slides />} />
              <Route path="usuarios" element={
                <ProtectedRoute rolesAllowed={['superadmin']}>
                  <Usuarios />
                </ProtectedRoute>
              } />
              <Route path="adminpage" element={<AdminPage />} />
              <Route index element={<AdminPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>          
        </div>
      </div>
    </Router>    
  );
};

export default App;